// import* as React from 'react';
import {Exception404} from 'components/Exception';


export default Exception404;
